import { DateText } from './ContentBase';

interface EReferralNotesContentProps {
  insightDetailsContent: {
    event_date?: string;
    detail?: {
      notes_to_clerk?: string | null;
    } | null;
  };
}

const EReferralNotesContent = ({
  insightDetailsContent,
}: EReferralNotesContentProps) => {
  const notesToClerk = insightDetailsContent?.detail?.notes_to_clerk ?? '-';

  return (
    <>
      <DateText date={insightDetailsContent?.event_date ?? ''} />
      <div className="description">
        <p>{notesToClerk || '-'}</p>
      </div>
    </>
  );
};

export default EReferralNotesContent;
